module.exports = __webpack_public_path__ + "media/images/flags/64/South-Georgia-and-the-South-Sandwich-Islands-50aed10c781f7e407306894f31c76db1.png";